import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";

function Links() {
  const sectionStyle = "mt-6";
  const titleStyle = "text-xl font-semibold mb-4";
  const listStyle = "mb-6";
  const itemTitle = "font-medium";
  const linkStyle = "text-blue-600 hover:underline break-all";

  function UNLinks() {
    return (
      <div className={listStyle}>
        <div className="mb-3">
          <p className={itemTitle}>
            • United Nations Map Library (UNGEGN documents)
          </p>
          <a
            className={linkStyle}
            href="http://www.un.org/depts/dhl/maplib/ungegn.htm"
          >
            http://www.un.org/depts/dhl/maplib/ungegn.htm
          </a>
        </div>

        <div className="mb-3">
          <p className={itemTitle}>• United Nations – Cartography</p>
          <a
            className={linkStyle}
            href="http://www.un.org/Depts/Cartographic/english/htmain.htm"
          >
            http://www.un.org/Depts/Cartographic/english/htmain.htm
          </a>
        </div>

        <div className="mb-3">
          <p className={itemTitle}>
            • United Nations – Second Administrative Level Boundaries (SALB)
          </p>
          <a className={linkStyle} href="http://www.unsalb.org">
            http://www.unsalb.org
          </a>
        </div>

        <div className="mb-3">
          <p className={itemTitle}>
            • National Mapping Agencies and contacts around the world
          </p>
          <a
            className={linkStyle}
            href="http://www.unsalb.org/index.php?option=com_content&view=article&id=47&Itemid=56"
          >
            http://www.unsalb.org/index.php?option=com_content&view=article&id=47&Itemid=56
          </a>
        </div>

        <div className="mb-3">
          <p className={itemTitle}>
            • United Nations Geographic Information Working Group
          </p>
          <a className={linkStyle} href="http://www.ungiwg.org/">
            http://www.ungiwg.org/
          </a>
        </div>

        <div className="mb-3">
          <p className={itemTitle}>• UNESCO Intangible Cultural Heritage</p>
          <a
            className={linkStyle}
            href="http://www.unesco.org/culture/intagible-heritage/masterpiece.php"
          >
            http://www.unesco.org/culture/intagible-heritage/masterpiece.php
          </a>
        </div>
      </div>
    );
  }

  function OrgLinks() {
    return (
      <div className={listStyle}>
        <div className="mb-3">
          <p className={itemTitle}>
            • International Council of Onomastic Sciences (ICOS)
          </p>
          <a className={linkStyle} href="http://www.icosweb.net">
            http://www.icosweb.net
          </a>
        </div>

        <div className="mb-3">
          <p className={itemTitle}>
            • International Hydrographic Organization (IHO)
          </p>
          <a className={linkStyle} href="http://www.iho-ohi.net/english/home">
            English: http://www.iho-ohi.net/english/home
          </a>
          <br />
          <a
            className={linkStyle}
            href="http://www.iho-ohi.net/francais/accueil"
          >
            French: http://www.iho-ohi.net/francais/accueil
          </a>
        </div>

        <div className="mb-3">
          <p className={itemTitle}>
            • GEBCO Gazetteer of Undersea Features / SCUFN
          </p>
          <a
            className={linkStyle}
            href="http://www.gebco.net/data_and_products/undersea_feature_names/"
          >
            http://www.gebco.net/data_and_products/undersea_feature_names/
          </a>
        </div>

        <div className="mb-3">
          <p className={itemTitle}>
            • International Organization for Standardization (ISO)
          </p>
          <a className={linkStyle} href="http://www.iso.ch/">
            http://www.iso.ch/
          </a>
        </div>

        <div className="mb-3">
          <p className={itemTitle}>
            • ISO Technical Committee (Geographic Information)
          </p>
          <a className={linkStyle} href="http://www.isotc211.org/">
            http://www.isotc211.org/
          </a>
        </div>

        <div className="mb-3">
          <p className={itemTitle}>
            • African Organization of Cartography and Remote Sensing (AOCRS)
          </p>
          <a className={linkStyle} href="http://www.oact.dz/oact/">
            http://www.oact.dz/oact/
          </a>
        </div>

        <div className="mb-3">
          <p className={itemTitle}>
            • Scientific Committee on Antarctic Research (SCAR)
          </p>
          <a
            className={linkStyle}
            href="http://www.scar.org/Publications/bulletins/webbull_138a.htm"
          >
            http://www.scar.org/Publications/bulletins/webbull_138a.htm
          </a>
        </div>

        <div className="mb-3">
          <p className={itemTitle}>• Unicode Consortium</p>
          <a
            className={linkStyle}
            href="http://www.unicode.org/unicode/consortium/memblogo"
          >
            http://www.unicode.org/unicode/consortium/memblogo
          </a>
        </div>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      {/* <div className="min-h-screen flex flex-col px-6 py-8 max-w-4xl mx-auto">
       */}
      {/* <div className="container mx-auto px-6 py-8 mb-20"> */}
      <div className="container mx-auto px-20 mb-20">
        <section className={sectionStyle}>
          <h2 className={titleStyle}>United Nations</h2>
          <UNLinks />
        </section>

        <section className={sectionStyle}>
          <h2 className={titleStyle}>International Organizations</h2>
          <OrgLinks />
        </section>
      </div>
      <Footer />
    </>
  );
}

export default Links;
